// This file is used for LOCAL DEVELOPMENT ONLY
// In production, configuration is loaded from /aws-exports.js (generated by Terraform)

const awsmobile = {
    Auth: {
        Cognito: {
            userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
            userPoolClientId: process.env.REACT_APP_COGNITO_USER_POOL_CLIENT_ID,
            region: process.env.REACT_APP_COGNITO_REGION
        }
    },
    API: {
        REST: {
            AdminAPI: {
                endpoint: process.env.REACT_APP_API_ENDPOINT,
                region: process.env.REACT_APP_COGNITO_REGION
            }
        }
    }
};

export default awsmobile;